/**
 * @generated SignedSource<<5ce0d5b6754da72abef453705fd8d8eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CloudCostType = "BilledCost" | "EffectiveCost" | "ListCost" | "%future added value";
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserContext_platform$data = {
  readonly avatarColor: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }>;
  };
  readonly platform: {
    readonly costReportingConfig: {
      readonly awsCostType: CloudCostType;
      readonly azureCostType: CloudCostType;
      readonly gcpCostType: CloudCostType;
    };
    readonly roleScopes: {
      readonly accountGroup: {
        readonly userPermissions: ReadonlyArray<Permission>;
      };
      readonly policyCollection: {
        readonly userPermissions: ReadonlyArray<Permission>;
      };
      readonly repository: {
        readonly userPermissions: ReadonlyArray<Permission>;
      };
      readonly system: {
        readonly userPermissions: ReadonlyArray<Permission>;
      };
    };
  };
  readonly whoami: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
    readonly user: {
      readonly ssoUser: boolean;
    };
  };
  readonly " $fragmentType": "UserContext_platform";
};
export type UserContext_platform$key = {
  readonly " $data"?: UserContext_platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserContext_platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userPermissions",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserContext_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Platform",
      "kind": "LinkedField",
      "name": "platform",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CostReportingConfig",
          "kind": "LinkedField",
          "name": "costReportingConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "awsCostType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "azureCostType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gcpCostType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleScopes",
          "kind": "LinkedField",
          "name": "roleScopes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleScope",
              "kind": "LinkedField",
              "name": "accountGroup",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleScope",
              "kind": "LinkedField",
              "name": "policyCollection",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleScope",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleScope",
              "kind": "LinkedField",
              "name": "system",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ssoUser",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "avatarColor",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "avatar_color"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"avatar_color\"}})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "6a58e3f87f5dd15c752cf8f9b01ab6cf";

export default node;
